
// Global default min and max order times
export const defaultMinTime = "7:00"
export const defaultMaxTime = "14:00"
export const defaultOrderTime = "7:00 - 7:45";